import { Fragment, useState } from "react";
import { useSignal } from "@preact/signals-react";
import { FormattedMessage as FM } from "react-intl";

import Dialog from "componentsv2/modal/Dialog";
import { BUTTON_COLORS } from "components/Constants/constants";
import { useWizard } from "storev2/wizardStore";
import { cn } from "tools/ui";

const styleBase =
  "flex space-x-3 justify-center items-center my-auto p-2 h-11 text-center border-[1px] rounded-xl shadow-md active:scale-95 active:shadow-lg";

function ModalWizard(props) {
  const open = useSignal(false);
  const signalReset = useSignal(0);
  const {
    layout,
    record,
    style,
    label,
    model,
    icon,
    color,
    Component,
    resetData,
    buttons,
    onReset,
    handleAccept,
    args,
    reload,
    parentStoreId,
    storeId,
  } = props;
  const [msg, setMsg] = useState(null);
  const { reset } = useWizard();

  const _color = color ?? "blue";
  const _style = style ?? "w-full";
  const [bgColor, txtColor, border] = BUTTON_COLORS[_color];

  function onCloseMsg() {
    setMsg(null);
  }

  // function resetWizard() {
  //   reset();
  // }

  async function onClose(update, error) {
    if (error) {
      setMsg(error);
      reset();
      return;
    }

    open.value = false;
    reset(); // Reset store wizard
    signalReset.value += 1; // Reset children UI
    if (resetData) {
      for (const field of Object.values(resetData)) {
        field.value = null;
      }
    }
    if (onReset) {
      onReset();
    }
  }

  function openModal() {
    if (layout?.defaults) {
      // This method set default values for the wizard
      layout.defaults();
    }
    open.value = true;
  }

  let mxLabel = "mx-auto";
  if (icon) {
    mxLabel = "";
  }

  return (
    <Fragment>
      <button
        type="button"
        onClick={openModal}
        className={cn(styleBase, bgColor, txtColor, border, _style)}
      >
        <span className={cn("w-fit my-auto", mxLabel)}>
          {label && <FM id={label} />}
        </span>
        {icon && icon}
      </button>
      <Dialog
        title={label}
        openModal={open}
        handleClose={onClose}
        handleAccept={handleAccept}
        buttons={buttons}
        titleSize="text-2xl"
        size="h-4/5 w-2/3"
      >
        <Component
          parentStoreId={parentStoreId}
          parentRec={record}
          model={model}
          onClose={onClose}
          layout={layout}
          signalReset={signalReset.value}
          args={args}
          reload={reload}
          storeId={storeId}
        />
      </Dialog>
    </Fragment>
  );
}

export default ModalWizard;
